export function buildAvatarUrlClient(avatarKey: string | null | undefined) {
  if (!avatarKey) return null
  const str = typeof avatarKey === 'string' ? avatarKey : String(avatarKey)
  if (str.startsWith('http://') || str.startsWith('https://')) return str

  // Use same logic as SettingsPage for frontend: prefer https://api.syncreos.com:8443 when in PROD, else http://localhost:8443
  const backendBase = import.meta.env.PROD ? "https://api.syncreos.com:8443" : "http://localhost:8443"
  const key = str.startsWith('/') ? str.substring(1) : str
  try {
    return `${backendBase.replace(/\/$/, '')}/uploads/images/${encodeURIComponent(key)}`
  } catch {
    return null
  }
}
